module.exports = __webpack_public_path__ + "img/about-1-570x350B.7e69823c.jpg";